import { Inject, Injectable } from '@angular/core';
import {
    GetOption,
    HateoasResourceOperation,
    PagedGetOption,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { ENVIRONMENT, Environment, ServiceEdgeRouterPolicy } from '@netfoundry-ui/shared/model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HTTP_CLIENT } from '@netfoundry-ui/shared/services';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ServiceEdgeRouterPolicyService extends HateoasResourceOperation<ServiceEdgeRouterPolicy> {
    static defaultPaginationSize = 500;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };
    lastPageCount = 0;
    lastTotalCount = 0;

    constructor(@Inject(HTTP_CLIENT) private http: HttpClient, @Inject(ENVIRONMENT) private environment: Environment) {
        super(ServiceEdgeRouterPolicy);
    }

    getResource(): Observable<ServiceEdgeRouterPolicy> {
        throw new Error('Do not use: see get getServiceEdgeRouterPolicy');
    }

    getPage(): Observable<PagedResourceCollection<ServiceEdgeRouterPolicy>> {
        throw new Error('Do not use: see getServiceEdgeRouterPolicys');
    }

    getServiceEdgeRouterPolicy(id, options: GetOption = {}): Promise<ServiceEdgeRouterPolicy> {
        return super
            .getResource(id, { ...ServiceEdgeRouterPolicyService.defaultHttpAccept, ...options })
            .toPromise()
            .then((servicePolicy) => servicePolicy);
    }

    async getServiceEdgeRouterPolicyPage(
        options?: PagedGetOption,
        includeProperties?: string
    ): Promise<ServiceEdgeRouterPolicy[]> {
        let params = { ...ServiceEdgeRouterPolicyService.defaultHttpAccept, ...options };
        if (includeProperties) {
            params = { ...params, headers: { accept: `application/hal+json;includeProperties=${includeProperties}` } };
        }
        return super
            .getPage(params)
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.totalPages;
                    this.lastTotalCount = val.totalElements;
                })
            )
            .toPromise()
            .then((servicePolicies) => servicePolicies.resources);
    }

    public validateUpdate(edgeRouterPolicyId: string, model: any) {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '');
        return this.http
            .patch(this.environment.v2apiUrl + 'service-edge-router-policies/' + edgeRouterPolicyId, model, {
                headers: headers,
                responseType: 'json',
            })
            .toPromise();
    }

    public async validateCreate(model: any) {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '');
        return this.http
            .post(this.environment.v2apiUrl + 'service-edge-router-policies', model, {
                headers: headers,
                responseType: 'json',
            })
            .toPromise();
    }

    public downloadFileFormat(
        networkId: string,
        format = 'text/csv',
        params: HttpParams = new HttpParams()
    ): Observable<any> {
        params = params.set('networkId', networkId);
        const headers = new HttpHeaders().set('Accept', format);
        return this.http.get(this.environment.v2apiUrl + 'service-edge-router-policies', {
            headers: headers,
            params: params,
            responseType: 'text',
        });
    }
}
